import clsx from "../../../modules/helpers/clsx";
import { useFocusable } from "../../../modules/spatialNavigation";
import * as styles from "./styles.module.scss";

interface IProps {
  focusKey: string;
  onClick: () => void;
}

const SliderLoadMoreButtonComponent = (props: IProps) => {
  const { ref, focused } = useFocusable({
    focusKey: props.focusKey,
    onEnterPress: props.onClick,
  });
  return (
    <button ref={ref} className={styles.button} onClick={props.onClick}>
      <span
        className={clsx({
          [styles.innerSection]: true,
          [styles.focused]: focused,
        })}
      >
        <span className={styles.content}>مشاهده بیشتر</span>
      </span>
    </button>
  );
};

export default SliderLoadMoreButtonComponent;
